import { TokenResponse } from '@sanlam-glacier/app-common/types/auth/token-response.type.js';
import { AuthenticationMethod } from 'auth/auth-methods/authentication-method.type';
import { useConfig } from 'providers/config/ConfigProvider';
import { useEffect } from 'react';

type UseSessionRefreshProps = {
  authApi: AuthenticationMethod;
  token: TokenResponse | undefined;
};

export const useSessionRefresh = ({ authApi, token }: UseSessionRefreshProps) => {
  const env = useConfig();
  useEffect(() => {
    const intervalId = setInterval(() => {
      (async () => {
        await authApi.refreshSessionIfExpired();
      })();
    }, env.auth.refreshIntervalSeconds * 1000);

    return () => clearInterval(intervalId);
  }, [authApi, env.auth.refreshIntervalSeconds, token]);
};
